import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { EntityType } from '@frontend/common';

export interface Identification {
    delete_timestamp: string | null;
    key: string;
    secret: string | null;
    entity_type: EntityType | null;
    entity_id: string | null;
    must_change_password?: boolean;
    valid_timestamp: string | null;
    update_timestamp: string | null;
    type: IdentificationType;
    id: string;
    account_id: string;
    creation_timestamp: string;
}

export interface CreateIdentification {
    key?: string;
    secret?: string | null;
    entity_type?: EntityType | null;
    entity_id?: string | null;
    must_change_password?: boolean;
    valid_timestamp?: string | null;
    update_timestamp?: string | null;
    type?: IdentificationType;
}

export interface UpdateIdentification {
    null_fields?: string[] | null;
    key?: string | null;
    secret?: string | null;
    entity_type?: EntityType | null;
    entity_id?: string | null;
    must_change_password?: boolean | null;
    valid_timestamp?: string | null;
    update_timestamp?: string | null;
}

export enum IdentificationType {
    ACCESS_KEY = 'access_key',
    ALIAS = 'alias',
    API_KEY = 'api_key',
    BADGE = 'badge',
    BARCODE = 'barcode',
    BASIC_AUTH = 'basic_auth',
    IDENTIFICATION = 'identification',
    IOT = 'iot',
    ITSME = 'itsme',
    REMOTE_ACCESS = 'remote_access',
    SSO = 'sso',
    TAG = 'tag',
    X_API_KEY = 'x_api_key'
}
export type IdentificationListResponse = PaginatedResponse<Identification>;

enum QueryParams {
    TYPE = 'type',
    ENTITY_TYPE = 'entity_type',
    ENTITY_ID = 'entity_id',
    KEY = 'key',
    UNLINKED = 'unlinked'
}

export type IdentificationQueryParams = QueryParams & DefaultQueryParams;
